<template>
  <div>
    <div class="styleSet">
      <div class="blueBackView">
          操作说明：<br>
          提交银行卡信息后，银行会向您的{{labelNames.isMaintenance}}银行卡转入小于等于0.5元的随机金额，并短信通知到经办人手机号，请您按短信提示，将指令序列号和银行卡收到的金额填写并提交。银行验证通过后，完成{{labelNames.isMaintenance}}账户绑定。
      </div>
    </div>
    <div class="link">
      <div style="width: 90%;text-align: right;">
        <span class="underline-link" @click="handleClick">未收到短信？点击此处重发</span>
      </div>
    </div>
    <div class="styleSet">
      <el-form style="width: 90%;" :rules="step2Rules" :label-width="labelWidth+'px'" :model="step2Form" inline  ref="step2Form">
        <el-col :span="12">
          <el-form-item :label="labelNames.accountIdName"  prop="accountId">
            <div>{{this.step2Form.accountId}}</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="labelNames.merchantNameFn"  prop="merchantName">
            <div>{{this.step2Form.merchantName}}</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="统一社会信用代码证号:" prop="licenceNo">
            <div>{{this.step2Form.licenceNo}}</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="经办人手机号:" prop="contactMobile">
            <div>{{this.step2Form.contactMobile}}</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="bankCardNo" :label="labelNames.bankCardNoName">
            <div>{{this.step2Form.bankCardNo}}</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="bankShortName" label="开户行名称:">
            <div>{{this.step2Form.bankShortName}}</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="verifyCode" label="指令序列号:">
            <el-input
              placeholder="请输入"
              v-model="step2Form.verifyCode"
              v-alphanumeric="true"
              maxlength = 20
              :controls="false"
              clearable>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="verifyAmount" label="鉴权金额:">
            <div style="display: flex;">
              <el-input
                @input="handleInput"
                placeholder="请输入"
                v-model="step2Form.verifyAmount"
                clearable>
              </el-input>
              <span style="margin-left: 5px;">元</span>
            </div>
          </el-form-item>
        </el-col>
      </el-form>
    </div>
  </div>
</template>
<script>

import { bankCardPreSign, bankCardSign } from '@/api/financeApi/walletWithhold'
import { limitMoreZero } from '@/utils/validate'
import config from './config'

export default {
  props: {
    stepsParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    const checkFormat = (rule, value, callback) => {
      if (value > 0.5) {
        return callback(new Error('大于随机转入金额'))
      } else if (value === '0') {
        return callback(new Error('交易金额须大于0'))
      } else {
        callback()
      }
    }
    const {
      labelNames,
    } = config.call(this)
    return {
      labelNames,
      labelWidth: 170,
      step2Form: {
        bankId: '', // 开户行id
        accountId: '', // 资金收款户ID
        merchantName: '', // 资金收款户公司主体全称
        licenceNo: '', // 统一社会信用代码证号
        bankCardNo: '', // 提现银行卡卡号
        bankShortName: '', // 开户行名称
        contactMobile: '', // 经办人手机号
        verifyCode: '', // 验证码，指令序列号
        verifyAmount: '', // 鉴权金额
      },
      step2Rules: {
        verifyAmount: [
          { required: true, message: '请填写鉴权金额', trigger: 'blur' },
          { validator: checkFormat, trigger: 'blur' },
        ],
        verifyCode: [
          { required: true, message: '请填写指令序列号', trigger: 'blur' },
        ],
      },
    }
  },
  created() {
    if (this.stepsParams) {
      this.step2Form.accountId = this.stepsParams.accountId
      this.step2Form.merchantName = this.stepsParams.merchantName
      this.step2Form.licenceNo = this.stepsParams.licenceNo
      this.step2Form.bankCardNo = this.stepsParams.bankCardNo
      this.step2Form.contactMobile = this.stepsParams.contactMobile
      this.step2Form.bankShortName = this.stepsParams.selectedOption
      this.bankId = this.stepsParams.bankShortName
    }

    if (this.$route.query) {
      this.origin = this.$route.query.origin || ''
    }
  },
  methods: {
    // 发送短信
    async handleClick() {
      // 银行卡预签约-第一步填写银行卡信息
      const { data } = await bankCardPreSign({
        accountId: this.step2Form.accountId,
        bankCardNo: this.step2Form.bankCardNo,
        bankId: this.bankId,
        contactMobile: this.step2Form.contactMobile,
        channelType: 6,
      })
      if (data === 1) {
        this.$message.success('操作成功')
      }
    },

    // mode: bind, change
    // eslint-disable-next-line vue/no-unused-properties
    submit(mode) {
      this.$refs.step2Form.validate(async (valid) => {
        if (valid) {
          try {
            // 银行卡预签约-第二步银行鉴权校验
            const { code } = await bankCardSign({
              accountId: this.step2Form.accountId,
              bankCardNo: this.step2Form.bankCardNo,
              verifyCode: this.step2Form.verifyCode,
              verifyAmount: this.step2Form.verifyAmount,
              mode,
            })
            if (code === 1) {
              this.$emit('success')
            } else {
              this.$emit('failed')
            }
          } catch (error) {
            this.$emit('failed')
          }
        } else {
          this.$emit('failed')
          this.$message.error('请填写必填项，并输入正确的信息格式')
        }
      })
    },
    handleInput(val) {
      limitMoreZero(val, (value) => {
        this.step2Form.verifyAmount = value
      }, 7)
    },
  },
}
</script>
<style scoped lang="scss">
.styleSet{
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 20px;
}
.blueBackView{
  width: 90%;
  background-color: #ECF3FF;
  color: #006AF5;
  padding-left: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 20px;
  border-radius: 5px;
}
.link{
  display: flex;width: 100%;
  justify-content: center;
  margin-top: 10px;
}
.underline-link {
  text-decoration: underline;
  color: #006AF5;
  cursor: pointer;
}
.btnStyle {
  width: 280px;
  display: flex;
  justify-content: space-between;
}
</style>

